export class HttpService {

  sendRequest(url, requestBody) {
    return fetch(url, requestBody).then(response => response.json())
  }
  
}
